<template>
  <div class="system-info text-align-center">
    <FlatIcon
      v-if="icon"
      :name="icon" />
    <div>
      <slot>
        <p>{{ message }}</p>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemInfo',
  props: {
    icon: {
      type: String
    },
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.system-info {
  padding: 20px;
  .flat-icon {
    margin-bottom: 1px;
  }
}
</style>
